import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import { OptionType } from '../../../types/utilities'
import Tooltip from '../../GeneralTextInput/Tooltip'
import { Title, Header, Asterisk, DivMain, DivIcon, Icon, DropdownIndicator, Placeholder } from './styles'
const CLASS_PREFIX = `generalSettings--statusSelect`

enum Status {
    true = 'Active',
    false = 'Inactive'
}
interface BooleanListProps {
    value: boolean
    title: string
    editMode: boolean
    required: boolean
    tooltip?: string
    onChange: (input: boolean) => void
}
const BooleanList = ({ onChange, title, value, editMode, required, tooltip }: BooleanListProps): JSX.Element => {
    return (
        <DivMain tabIndex={0} disabled={!editMode}>
            <Header>
                <Title>{title}</Title>
                {tooltip ? (
                    <DivIcon>
                        <Tooltip 
                            className={'inputBoolean_tooltip'} 
                            text={tooltip} 
                            maxWidth={'180px'}
                        />
                        <Icon className={'far fa-info-circle'} />
                    </DivIcon>
                ) : null}
                {required ? <Asterisk>*</Asterisk> : null}
            </Header>
            <StyledDropdownSelect
                classNamePrefix={CLASS_PREFIX}
                options={
                    [
                        { label: Status.true, value: true },
                        { label: Status.false, value: false }
                    ] as OptionType[]
                }
                placeholder={'---'}
                onChange={(selected: OptionType) => onChange(selected.value as boolean)}
                isDisabled={!editMode}
                value={{ label: Status[value.toString()], value }}
                // styles={SelectStyles}
                components={{ DropdownIndicator, Placeholder }}
                isSearchable={false}
            />
        </DivMain>
    )
}

export default BooleanList

export const StyledDropdownSelect = styled(Select)<{ classNamePrefix: string }>`
    background: transparent;

    .${({ classNamePrefix }) => classNamePrefix}__option {
        color: ${props => props.theme['blue-500']};
        &--is-selected {
            color: ${props => props.theme['gray-0']};
        }
    }
    .${({ classNamePrefix }) => classNamePrefix}__control {
        height: 35px;
        min-height: 35px;
        background: transparent;
        margin: -2px -8px !important;
        &,
        &--is-focused {
            border: none;
            box-shadow: none;
        }
    }
    .${({ classNamePrefix }) => classNamePrefix}__indicator-separator {
        display: none;
    }
`
